import { render, staticRenderFns } from "./AccountingMenu.vue?vue&type=template&id=03173f86"
import script from "./AccountingMenu.vue?vue&type=script&lang=js"
export * from "./AccountingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports